<div *ngIf="loading | async" class="full-screen-center" ngClass="loading">
    <div class="text-primary" role="status">
        <img src="../../../assets/Logo/spinner-border.gif" alt="Spinner" id="spinner">
    </div>
</div>
<div >
    <router-outlet></router-outlet>
</div>